// Lasting Power of Attorney (LPA) Webinar (lpa.affinitygroup.sg)
// Sessions confirmed (Nov 2026). Keep the ISO dates in sync with backend/seminars/lpa.py and ZOOM_WEBINAR_MAP.
import en from "./en";
import zh from "./zh";

const lpa = {
  id: "lpa",
  theme: "lpa",
  registrationClosed: false,
  storagePrefix: "affinityLpa",
  siteName: "Affinity LPA Webinar",
  webinar: { en: "Lasting Power of Attorney (LPA) webinar", zh: "《持久授权书（LPA）》线上讲座" },
  topic: { en: "the Lasting Power of Attorney", zh: "持久授权书" },
  admin: { kicker: "LPA dashboard", subtitle: "Lasting Power of Attorney · Registrations", tag: "LPA" },
  pixelContentName: "LPA Webinar Registration",
  guide: { handbook: true, deck: false },
  dictionaries: { en, zh },
  sessions: [
    { iso: "2026-11-14T10:00:00+08:00", language: "English", langCode: "en", speakerId: "nicholas", speaker: "Nicholas Lee", label: { en: "Saturday, 14 November 2026", zh: "2026年11月14日（星期六）" }, short: { en: "14 Nov 2026", zh: "11月14日" } },
    { iso: "2026-11-21T10:00:00+08:00", language: "Chinese", langCode: "zh", speakerId: "vincent", speaker: "Vincent Chua 蔡镇安", label: { en: "Saturday, 21 November 2026", zh: "2026年11月21日（星期六）" }, short: { en: "21 Nov 2026", zh: "11月21日" } },
  ],
  videos: {
    en: [{ id: "1224428234", hash: "051ce666c1", speaker: "Nicholas Lee", caption: "Physical seminar · 2025", title: "LPA Seminar 2025 highlights and attendee testimonials" }],
    zh: [{ id: "1224428234", hash: "051ce666c1", speaker: "Affinity Group", caption: "实体讲座 · 2025年", title: "2025年持久授权书实体讲座精彩回顾与学员分享" }],
  },
  questionIds: ["what", "donee", "without", "family", "combine", "unsure", "other"],
};

export default lpa;
